<template>
  <div class="callback">
    <h1>打假办收到举报信息后</h1>
    <p>1、进一步确认信息</p>
    <p>2、采取打假行动</p>
    <p>3、奖励举报人</p>
    <div class="footer">
      <button @click="back">返回举报界面</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back: function () {
      this.$router.push("/tip");
    }
  }
}
</script>

<style lang="stylus" scoped>
.callback {
  color: #231815;

  h1 {
    font-size: 0.652778rem;
    text-align: center;
    margin: 1.527778rem auto;
  }

  p {
    font-size: 0.583333rem;
    width: 5.194444rem;
    margin: 0 auto;
    font-weight: 400;
    color: #3E3A39;
    line-height: 1.75rem;
  }

  .footer {
    position: fixed;
    bottom: 1.388889rem;
    width: 100%;
    text-align: center;

    button {
      border: none;
      background: transparent;
      color: #1B92D2;
      font-size: 0.5rem;
      border-bottom: 1px solid #1B92D2;
      padding: 0.138889rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example01/callback.vue